import {Component, Inject} from "@angular/core";
import {formatDate} from '@angular/common';
import {FormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {lastValueFrom} from 'rxjs';
import {VentanaFlotante} from "../models/VentanaFlotante";
import {Validadores} from "../validadores";
import {HojasCallCenterComponent} from '../hojas-call-center.component';
import {getErrorMessage} from '../helpers/error';
import {BdService} from '../services/bd.service';
import {AbancaService} from '../services/bd/CallCenter/abanca.service';

@Component({
  selector: 'ral-colaborador-abanca',
  templateUrl: './abanca.component.html',
  styleUrls: ['./abanca.component.scss']
})
export class AbancaComponent extends VentanaFlotante
{
  protected busquedaForm = this.formBuilder.group({
    matricula: ["", [Validators.required, Validadores.matricula()]],
  });
  protected encontrado = false;
  protected buscando = false;
  protected poliza = "";
  protected nombre = "";
  protected apellidos = "";
  protected direccion = "";
  protected codigoPostal = "";
  protected localidad = "";
  protected marca = "";
  protected modelo = "";
  protected nif = "";
  protected email = "";
  protected telefonos = ["", ""];
  protected fechaInicioContrato = "";
  protected fechaVencimientoContrato = "";
  protected fechaInicioCobertura = "";
  protected siniestro = "";
  private formularioHojas: HojasCallCenterComponent;

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: {formularioHojas: HojasCallCenterComponent},
    private formBuilder: FormBuilder,
    private abanca: AbancaService,
    private bd: BdService,
  )
  {
    super(dialogRef, data);
    this.formularioHojas = data.formularioHojas;
  }

  async buscar() {
    try {
      const busqueda = this.busquedaForm.value;
      this.buscando = true;
      const polizas$ = this.abanca.buscarPoliza(this.formularioHojas.token, busqueda.matricula!);
      const polizas = await lastValueFrom(polizas$);
      if (polizas.length === 0) {
        this.formularioHojas.mostrarArgumentario("Matrícula no encontrada", ["No se ha podido encontrar esta matrícula."], false, true, true);
        // no cambiamos `encontrado` para dejar los valores anteriors, si habían.
      } else {
        const poliza = polizas[0];
        this.encontrado = true;
        this.poliza = String(poliza.id_poliza);
        this.nombre = poliza.nombre;
        this.apellidos = poliza.apellidos_razonsocial;
        this.direccion = poliza.direccion;
        this.codigoPostal = poliza.cp;
        this.localidad = poliza.localidad;
        this.marca = poliza.marca;
        this.modelo = poliza.modelo;
        this.nif = poliza.nif;
        this.email = poliza.email;
        this.telefonos = [ poliza.telefono_1, poliza.telefono_2 ];
        this.fechaInicioContrato = formatDate(poliza.fecha_ini_contrato, "dd/MM/YYYY", "en");
        this.fechaInicioCobertura = formatDate(poliza.fecha_ini_cobertura, "dd/MM/YYYY", "en");
        this.fechaVencimientoContrato = formatDate(poliza.fecha_ven_contrato, "dd/MM/YYYY", "en");
      }
    } catch (e) {
      this.formularioHojas.mostrarArgumentario("Error al buscar", ["El servidor ha devuelto el siguiente error:", getErrorMessage(e)], false, true, true);
    } finally {
      this.buscando = false;
    }
  }

  async generarSiniestro() {
    try {
      this.buscando = true;
      const result = await lastValueFrom(this.bd.siguienteCodigoSiniestro(this.formularioHojas.token));
      this.siniestro = result.toString();
    } catch (e) {
      this.formularioHojas.mostrarArgumentario("Error al guardar", ["El servidor ha devuelto el siguiente error:", getErrorMessage(e)], false, true, true);
    } finally {
      this.buscando = false;
    }
  }

  guardar() {
    const hoja = this.formularioHojas;
    hoja.rellenarDeMatricula({
      nif_per: this.nif,
      titular: (this.nombre.substring(0, 80) + " " + this.apellidos.substring(0, 80)).trim(),
      dir_per: this.direccion + ", " + this.codigoPostal,
      tel_per: this.telefonos[0] ?? "",
      e_m_per: this.email,
      poliza: this.poliza,
      siniestro: this.siniestro,
      fec_sin: "",
      repre: "",
      marca: this.marca.substring(0, 10),
      modelo: this.modelo,
      bastidor: "",
      km: 0,
      del: 0,
      cliente: "",
      suc_lloc: "",
      case_id: ""
    });
    const form = this.busquedaForm.value;
    hoja.matriculaFormControl.setValue(form.matricula ?? "");
    this.dialogRef.close();
  }
}
